import * as types from "./types";
import {BuscarSolicitudRequest} from "../../../request/BuscarSolicitudRequest/BuscarSolicitudRequest";

export const consultarSolicitud = (requestBody: BuscarSolicitudRequest) => ({
  body: requestBody,
  type: types.CONSULTAR_SOLICITUD
});

export const solicitudConsultada = (payload) => ({
  payload,
  type: types.SOLICITUD_CONSULTADA
});

export const errorConsultandoSolicitud = (error) => ({
  type: types.ERROR_CONSULTANDO_SOLICITUD,
  error: error
});

export const consultarTiposSolicitud = () => ({
  type: types.CONSULTAR_TIPOS_SOLICITUD
});

export const tiposSolicitudConsultados = (payload) => ({
  payload,
  type: types.TIPOS_SOLICITUD_CONSULTADOS
});

export const errorConsultandoTiposSolicitud = (error) => ({
  type: types.ERROR_CONSULTANDO_TIPOS_SOLICITUD,
  error: error
});

export const limpiarEstadoBusquedaSolicitud = () => ({
  type: types.LIMPIAR_BUSQUEDA_SOLICITUD
});
